import React from "react";
import { useRouteMatch } from "react-router-dom";
import ContentContainer from "components/Container";

export const NotFound = () => {
  console.log("route", useRouteMatch()); // eslint-disable-line no-console

  // TODO: Move over to using the <EmptyState /> component
  return <ContentContainer>404</ContentContainer>;
};
